var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStress4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,146.5c-37.8,0-68.5-30.7-68.5-68.5C9.5,40.2,40.2,9.5,78,9.5c37.8,0,68.5,30.7,68.5,68.5 C146.5,115.8,115.8,146.5,78,146.5z M78,14.3c-35.1,0-63.7,28.6-63.7,63.7s28.6,63.7,63.7,63.7s63.7-28.6,63.7-63.7 S113.1,14.3,78,14.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.1,
    cy: 67.8,
    rx: 4.8,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.7,
    cy: 67.8,
    rx: 4.8,
    ry: 6.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54,115.9c3.3-2.2,7.7-3.4,12.4-3.4h34.5c1.1,0,2.1-0.6,2.1-1.4s-0.9-1.4-2.1-1.4H66.4c-5.8,0-11.2,1.5-15.3,4.2 c-0.8,0.5-0.8,1.4,0,1.9S53.2,116.4,54,115.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.1,115.9c-3.3-2.2-7.7-3.4-12.4-3.4H64.2c-1.1,0-2.1-0.6-2.1-1.4s0.9-1.4,2.1-1.4h34.5c5.8,0,11.2,1.5,15.3,4.2 c0.8,0.5,0.8,1.4,0,1.9C113.2,116.4,111.9,116.4,111.1,115.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress4);
export default __webpack_public_path__ + "static/media/Stress4.b7abe0331789bfdde25e17a862acc0af.svg";
export { ForwardRef as ReactComponent };